import React from 'react';
import { PartyType } from '../../../../../../../../../types/SMT';
import { InsurancePolicyType } from '../../../../../../types/AdvisoryReport';
import { RiskType } from '../../../shared/InsuranceProductSearch';
import { Page } from '../../hooks/useInsurancePolicyModal';
import AddInsuranceModalRiskPage from './coverage-form/AddInsuranceModalRiskPage';
import AddInsuranceModalInsuranceForm from './insurance-form/AddInsuranceModalInsuranceForm';

interface Props {
  page: Page;
  selectedRisk?: string;
  selectedRiskId?: string;
  onRemoveCoverage?: () => void;
  type: InsurancePolicyType;
  partyType?: PartyType;
  selectedRiskType?: RiskType;
  hideAIBanner?: boolean;
}

const AddInsuranceModalForms: React.FC<Props> = ({
  page,
  onRemoveCoverage,
  selectedRisk,
  selectedRiskId,
  selectedRiskType,
  type,
  partyType,
  hideAIBanner,
}) => {
  if (page.type === 'COVERAGE' && selectedRisk && page.index != null) {
    return (
      <AddInsuranceModalRiskPage
        key={selectedRisk}
        mode="EDIT"
        riskIndex={page.index}
        risk={selectedRisk}
        riskId={selectedRiskId}
        riskType={selectedRiskType}
        onRemove={onRemoveCoverage}
        partyType={partyType}
        type={type}
      />
    );
  }
  return (
    <AddInsuranceModalInsuranceForm hideAIBanner={hideAIBanner} type={type} />
  );
};

export default AddInsuranceModalForms;
